import ArticleLayout from '@/components/base/ArticleLayout';
import { articleStrategie } from '@/mocks/articles';

export default function ArticleStrategie() {
  return <ArticleLayout article={articleStrategie} currentSlug="/strategie-ricerca-prodotti" />;
}